import React from 'react';
import CoachesSlider from "./Coaches/CoachesSlider";

function App() {
  return (
    <div className="">
      <CoachesSlider />
    </div>
  );
}

export default App;
